<template>
  <div class="onboarding-error">
    <div class="onboarding-error-message">
      <Icon name="error"/>
      <h3>Ops! Houve um erro ao carregar o conteúdo.</h3>
    </div>

    <div class="onboarding-error-button">
      <Button class="primary" theme="ame" @click="handleClick">
        <Icon name="refresh"/>
        <span>Tentar novamente</span>
      </Button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';
import Button from '@/components/ui/AppButton.vue';

export default {
  name: 'error',
  components: { Icon, Button },
  methods: {
    handleClick() {
      this.$router.replace({
        name: 'onboarding-minified-instructions',
        query: this.$route.query,
      }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-error {
    height: 100vh;

    display: grid;
    grid-template-rows: 6fr 1fr;

    margin: 0 24px;
    align-items: center;

    .onboarding-error-message {
      display: flex;
      text-align: center;
      flex-direction: column;
      margin: 0 81px;

      h3 {
        font-weight: 400;
        line-height: 28px;
        margin-top: 20px;
      }
    }

    .onboarding-error-button {
      width: 100%;

      button {
        @extend .primary;
        background: #ed0059;
        font-weight: 600;
        border: none;
        color: #ffffff;
        height: 48px;
        width: 100%;
      }
    }
  }
</style>
